import Integrations_Connectors_AdminConfigureConnectorPage from "@Integrations/Connectors/Pages/AdminConfigureConnectorPage.vue"
import Integrations_Connectors_AdminConnectorDetailsPage from "@Integrations/Connectors/Pages/AdminConnectorDetailsPage.vue"
import Integrations_Connectors_AdminManageConnectorPage from "@Integrations/Connectors/Pages/AdminManageConnectorsPage.vue"

export const routes = [
    // admin pages
    {
        path: "/admin/integrations/connectors/configure/:id",
        component: Integrations_Connectors_AdminConfigureConnectorPage
    },
    {
        path: "/admin/integrations/connectors/details/:id",
        component: Integrations_Connectors_AdminConnectorDetailsPage
    },
    {
        path: "/admin/integrations/connectors/manage/:tid",
        component: Integrations_Connectors_AdminManageConnectorPage
    },
]
